
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/toys",
      function () {
        return require("private-next-pages/explore/toys/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/toys"])
      });
    }
  